export default (state, param) => {
  if (param.domain) {
    state.info.domain = param.domain
  }
  if (param.appId) {
    state.info.appId = param.appId
  }
  if (param.channelId) {
    state.info.channelId = param.channelId
  }
  if (param.channelName) {
    state.info.channelName = param.channelName
  }
  if (param.email) {
    state.info.email = param.email
  }
  if (param.package) {
    state.info.package = param.package
  }
  if (param.customToken) {
    state.info.customToken = param.customToken
  }
  if (param.lang) {
    state.info.lang = param.lang
  }
  if (param.colorMain) {
    state.info.colorMain = param.colorMain
  }
  if (param.colorSub) {
    state.info.colorSub = param.colorSub
  }
}
